export default __webpack_public_path__ + "static/ups-shot-b059c106e56ed48469fbeaaf434c01d2.jpg";